import { OrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/types';
import { SearchCatalogForOrderGuideQuery } from '@/types';
import { toOrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/transformers/order-guide-item-transformer';

// Catalog rows share the `SalesPortalOrderGuideItem` shape with the editor's
// items and carry no `entry_info`, so they reuse the same mapper at par null.
export const transformSearchCatalogResponse = (
  data: SearchCatalogForOrderGuideQuery | undefined,
): OrderGuideItem[] =>
  (data?.searchCatalogForOrderGuideItems ?? []).map(toOrderGuideItem);
